import type { PropertyStaffRow } from '../types'

export function computeDomainMode(list: PropertyStaffRow[]): string {
  const domainslist: string[] = []
  list.forEach((staff) => {
    const em = staff.email
    if (em && typeof em === 'string' && em.includes('@')) {
      domainslist.push(em.split('@')[1] || '')
    }
  })
  if (!domainslist.length) return ''
  return (
    domainslist
      .sort(
        (a, b) => domainslist.filter((v) => v === a).length - domainslist.filter((v) => v === b).length,
      )
      .pop() || ''
  )
}

export function draftTransferStaff(
  type: 'remove' | 'transfer',
  lists: {
    transferstaffList: PropertyStaffRow[]
    selectedTransferRoleList: PropertyStaffRow[]
    removestaffList: PropertyStaffRow[]
    selectedRemoveRoleList: PropertyStaffRow[]
  },
  setters: {
    setRemovestaffList: (fn: (r: PropertyStaffRow[]) => PropertyStaffRow[]) => void
    setTransferstaffList: (fn: (t: PropertyStaffRow[]) => PropertyStaffRow[]) => void
    setSelectedTransferRoleList: (v: PropertyStaffRow[]) => void
    setSelectedRemoveRoleList: (v: PropertyStaffRow[]) => void
  },
) {
  if (type === 'remove' && lists.transferstaffList.length && lists.selectedTransferRoleList.length) {
    const move = [...lists.selectedTransferRoleList]
    setters.setRemovestaffList((r) => [...r, ...move])
    setters.setTransferstaffList((t) => t.filter((x) => !move.some((m) => m.role_id === x.role_id)))
    setters.setSelectedTransferRoleList([])
  }
  if (type === 'transfer' && lists.removestaffList.length && lists.selectedRemoveRoleList.length) {
    const move = [...lists.selectedRemoveRoleList]
    setters.setTransferstaffList((t) => [...t, ...move])
    setters.setRemovestaffList((r) => r.filter((x) => !move.some((m) => m.role_id === x.role_id)))
    setters.setSelectedRemoveRoleList([])
  }
}

export function selectAllTransferStaff(
  checked: boolean,
  kind: 'remove' | 'transfer' | 'new',
  lists: {
    removestaffList: PropertyStaffRow[]
    transferstaffList: PropertyStaffRow[]
    addedstaffList: PropertyStaffRow[]
  },
  setters: {
    setSelectedRemoveRoleList: (v: PropertyStaffRow[]) => void
    setSelectedTransferRoleList: (v: PropertyStaffRow[]) => void
    setSelectedAddRoleList: (v: PropertyStaffRow[]) => void
  },
) {
  if (kind === 'remove') {
    setters.setSelectedRemoveRoleList(checked ? [...lists.removestaffList] : [])
  } else if (kind === 'transfer') {
    setters.setSelectedTransferRoleList(checked ? [...lists.transferstaffList] : [])
  } else {
    setters.setSelectedAddRoleList(checked ? [...lists.addedstaffList] : [])
  }
}

export function userSelectedTransferStaff(
  checked: boolean,
  user: PropertyStaffRow,
  type: 'remove' | 'transfer' | 'new',
  lists: {
    selectedRemoveRoleList: PropertyStaffRow[]
    selectedTransferRoleList: PropertyStaffRow[]
    selectedAddRoleList: PropertyStaffRow[]
  },
  setters: {
    setSelectedRemoveRoleList: (v: PropertyStaffRow[]) => void
    setSelectedTransferRoleList: (v: PropertyStaffRow[]) => void
    setSelectedAddRoleList: (v: PropertyStaffRow[]) => void
  },
) {
  const pick = (list: PropertyStaffRow[], set: (v: PropertyStaffRow[]) => void) => {
    if (checked) set([...list, user])
    else set(list.filter((x) => x.role_id !== user.role_id))
  }
  if (type === 'remove') pick(lists.selectedRemoveRoleList, setters.setSelectedRemoveRoleList)
  if (type === 'transfer') pick(lists.selectedTransferRoleList, setters.setSelectedTransferRoleList)
  if (type === 'new') pick(lists.selectedAddRoleList, setters.setSelectedAddRoleList)
}
